/**
 * validateReferral.js
 * Written by: Alex Kasemir
 */
import { removeStorage } from '@minerva-analytics/pantheon';
import request from 'store/request/actions';
import referralUser from 'store/user/selectors/referralUser';


export const VALIDATE_REFERRAL_START = `VALIDATE_REFERRAL_START`;
export const VALIDATE_REFERRAL_SUCCESS = `VALIDATE_REFERRAL_SUCCESS`;
export const VALIDATE_REFERRAL_FAILURE = `VALIDATE_REFERRAL_FAILURE`;

export const validateReferralStart = () => ({
  type: VALIDATE_REFERRAL_START,
});

export const validateReferralSuccess = (friends) => ({
  type: VALIDATE_REFERRAL_SUCCESS,
  friends,
});

export const validateReferralFailure = (error) => ({
  type: VALIDATE_REFERRAL_FAILURE,
  error,
});

/**
 * This will link people who are sign up through referrals
 * 1. Will check if there is a user id in the referral
 *   a. Yes -> connect the two users as referred friends
 *   b. No -> no referral request will be made
 * 2. Then, will direct users to the profile page
 */
export const validateReferral = () => {
  return async (dispatch, getState) => {
    dispatch(validateReferralStart());
    const refUser = referralUser(getState());
    if (refUser.id === getState().user.session.authedUserId) {
      removeStorage({ key: `referral-token`, session: true });
      dispatch(validateReferralFailure({ detail: `Self Referral` }));
      return;
    }

    try {
      const response = await dispatch(request(`/friends/referral/`, `POST`, { referrer_id: refUser.id }));
      removeStorage({ key: `referral-token`, session: true });
      dispatch(validateReferralSuccess(response.data));
    } catch (error) {
      removeStorage({ key: `referral-token`, session: true });
      dispatch(validateReferralFailure(error.data));
    }
  };
};
